import React from "react";
import {
  Box,
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  Flex,
  Heading,
  SimpleGrid,
  Text,
  VStack,
} from "@chakra-ui/react";
import { plans } from "../hooks/plans";

const CheckOutPage: React.FC = () => {

  const handleCheckout = (planId: string) => {
    // Example Paddle Checkout trigger
    // window.Paddle.Checkout.open({ product: planId });
    alert(`Checkout initiated for plan: ${planId}`);
  };

  return (
    <Container maxW="container.lg" py={12}>
      <VStack spacing={10}>
        <Heading size="2xl" textAlign="center">
          Choose Your Plan
        </Heading>
        <SimpleGrid columns={[1, 1, 3]} spacing={8} w="full">
          {plans.map((plan) => (
            <Card key={plan.name} shadow="lg" borderRadius="2xl">
              <CardHeader>
                <Heading size="lg" textAlign="center">
                  {plan.name}
                </Heading>
              </CardHeader>
              <CardBody>
                <VStack spacing={4}>
                  <Text fontSize="2xl" fontWeight="bold">
                    {plan.price}
                  </Text>
                  <VStack spacing={2} align="start">
                    {plan.features.map((feature, i) => (
                      <Text key={i}>• {feature}</Text>
                    ))}
                  </VStack>
                  <Button
                    colorScheme="green"
                    w="full"
                    onClick={() => handleCheckout(plan.name)}
                  >
                    Select Plan
                  </Button>
                </VStack>
              </CardBody>
            </Card>
          ))}
        </SimpleGrid>
      </VStack>
    </Container>
  );
};

export default CheckOutPage;
